export function MascaraRg(value) {
    if (!value) return "";

    // remove tudo que não é número
    value = value.replace(/\D/g, "");

    // limita a 9 dígitos
    if (value.length > 9) value = value.slice(0, 9);

    // aplica a máscara: 99.999.999-9
    value = value.replace(/(\d{2})(\d)/, "$1.$2");

    value = value.replace(/(\d{3})(\d)/, "$1.$2");

    value = value.replace(/(\d{3})(\d{1})$/, "$1-$2");

    return value;
}